import React from 'react'
import './index.css'

const index = () => {
    return (
        <div className="wrapper">
            <div className="content-wrapper-404">
                <h1>404</h1>
                <p>Page not found</p>
            </div>
        </div>
    )
}

export default index
